module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.5eb10fd5.svg";